export default __webpack_public_path__ + "static/media/ExecutorPcDescriptionBack.6a772e21.svg";